import { generateHTML, JSONContent } from '@tiptap/core'
import { getExtensions } from 'client/components/core/tiptap-editor/utils/get-extensions'
import {
  extractDraftJson,
  isDraftLike,
} from 'client/components/core/tiptap-editor/utils/is-draft-content'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import EntityInterface, {
  EntityUnionType,
} from 'common/types/entities/EntityInterface'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { convertDraftToTiptap } from 'common/utils/convert-draft-to-tiptap'
import ServerPage from 'server/types/ServerPageInterface'
import { BlockInterface } from 'client/types/BlockInterface'
type DraftConvertibleBlock =
  | TextInterface
  | BulletListInterface
  | HeadlineInterface
  | CheckboxInterface

function isText(entity: EntityInterface) {
  return (
    entity.type === EntityTypeEnum.Text ||
    entity.type === EntityTypeEnum.BulletList ||
    entity.type === EntityTypeEnum.Headline ||
    entity.type === EntityTypeEnum.Checkbox
  )
}

//browser rendering
export const browserMigrateDraftJsToTiptap = (
  page: ServerPage,
): [ServerPage, boolean] => {
  let hasChanged = false

  const data = migrateDraftjsToTiptap({ page, hasChanged })

  return [
    {
      ...page,
      content: {
        ...page.content,
        entities: data.newEntities,
      },
    },
    data.hasChanged,
  ]
}

const convertDraftContent = (
  entity: DraftConvertibleBlock,
  isBulletList: boolean,
) => {
  const draft = extractDraftJson(entity.content || '')
  return draft.startsWith('{')
    ? generateHTML(
        convertDraftToTiptap(draft) as JSONContent,
        getExtensions(true, isBulletList),
      )
    : entity.content
}

type MigrateDraftjsToTiptapType =
  | {
      readonly isBlock: true
      block: BlockInterface
      page?: never
      hasChanged: boolean
    }
  | {
      readonly isBlock?: false
      page: ServerPage
      block?: never
      hasChanged: boolean
    }

export const migrateDraftjsToTiptap = (props: MigrateDraftjsToTiptapType) => {
  const newEntities: Record<string, EntityUnionType> = {}

  const { isBlock, block, page, hasChanged } = props
  let hasChangedLocal = hasChanged
  const entitiesArray = isBlock
    ? block.content
    : Object.values(page.content.entities)

  // biome-ignore lint/complexity/noForEach: <explanation>
  entitiesArray.forEach(entity => {
    if (isText(entity as EntityInterface)) {
      const { rawContentState, ...rest } = entity as DraftConvertibleBlock
      const isBulletList = entity.type === EntityTypeEnum.BulletList
      if (rawContentState) {
        let content = rest.content
        if (content && isDraftLike(content)) {
          content = convertDraftContent(
            entity as DraftConvertibleBlock,
            isBulletList,
          )
        } else if (!content) {
          content = generateHTML(
            convertDraftToTiptap(rawContentState) as JSONContent,
            getExtensions(true, isBulletList),
          )
        }

        newEntities[entity.id] = { ...rest, content } as DraftConvertibleBlock
        hasChangedLocal = true
        return
      }
      if (rest.content && isDraftLike(rest.content)) {
        const content = convertDraftContent(
          entity as DraftConvertibleBlock,
          isBulletList,
        )

        newEntities[entity.id] = {
          ...rest,
          content,
        } as DraftConvertibleBlock
        hasChangedLocal = true
        return
      }
    }

    newEntities[entity.id] = entity
  })

  return { newEntities, hasChanged: hasChangedLocal }
}
